import React from 'react'
import {CircularProgress, makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import IconButton from "./IconButton";

const useStyles = makeStyles(theme => ({
    fabProgress: {
        position: 'absolute',
        left: 0,
        top: 0
    }
}))

function WorkableIconButton(
    {
        working,
        disabled,
        ...props
    }) {
    const classes = useStyles();
    return (
        <IconButton  disabled={!!disabled || !!working} {...props}>
            {working && <CircularProgress size={48} className={classes.fabProgress}/>}
        </IconButton>
    )
}

WorkableIconButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.elementType]),
    hideTooltip: PropTypes.bool,
    Icon: PropTypes.elementType,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconButton;